import { WarningFilled } from "@ant-design/icons";
import { Button, Typography } from "antd";
import CustomModal from "components/CustomModal";
import { t } from "i18next";
import React from "react";
import useModalCreateOrder from "./useModalCreateOrder";

const ModalCreateOrder = ({ data, form, shippingTypes }) => {
  const { validateCreateOrder, onOpenCreateOrder, isVisible, onCancel, onCreateOrder, loading, isMissingPickupInfo } =
    useModalCreateOrder({ data, form, shippingTypes });
  const { variant, title, message, hideConfirmButton, hideCancelButton, okeButtonLabel } = validateCreateOrder();

  const isInvalidShippingType = variant === "invalidShippingType";

  return (
    <div style={isMissingPickupInfo ? { pointerEvents: "none" } : undefined}>
      {/* Tự quản `visible` thay vì để `CustomModal` tự mở: `openModal` của nó set visible NGAY rồi
          mới gọi `onOpen`, nên validate form không chặn được popup xác nhận. */}
      <Button type="primary" disabled={isMissingPickupInfo} onClick={onOpenCreateOrder}>
        {t("cart.createOrder")}
      </Button>
      <CustomModal
        selfVisibleControlled={false}
        visible={isVisible}
        customIcon={isInvalidShippingType && <WarningFilled style={{ fontSize: 48, color: "#ff4d4f" }} />}
        title={<b>{title}</b>}
        message={message && <Typography.Text>{message}</Typography.Text>}
        footer={false}
        centered={true}
        hideConfirmButton={hideConfirmButton}
        hideCancelButton={hideCancelButton}
        okeButtonLabel={okeButtonLabel}
        onCancel={onCancel}
        // PTVC không hợp lệ: nút hành động chỉ để đóng popup, không tạo đơn — Sale tự chọn lại PTVC
        // ngay trên màn (đã bị reset về undefined ở useList.js) rồi bấm "Tạo đơn" lại từ đầu.
        onOke={isInvalidShippingType ? onCancel : onCreateOrder}
        buttonLoading={loading}
      />
    </div>
  );
};

export default ModalCreateOrder;
